import { render, staticRenderFns } from "./MenageEditor.vue?vue&type=template&id=18595b4d"
import script from "./MenageEditor.vue?vue&type=script&lang=js"
export * from "./MenageEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports